/* eslint-disable react-refresh/only-export-components */
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/utils';

// One badge, five tones (DESIGN.md §5). Status badges map status → tone; the
// label always carries the meaning, the color is the second signal.
const badgeVariants = cva(
  'inline-flex h-6 max-w-full items-center gap-1 whitespace-nowrap rounded-md border px-2 text-xs font-medium',
  {
    variants: {
      variant: {
        neutral: 'border-transparent bg-muted text-muted-foreground',
        info: 'border-transparent bg-info/10 text-info-text',
        success: 'border-transparent bg-success/10 text-success-text',
        warning: 'border-transparent bg-warning/15 text-warning-text',
        danger: 'border-transparent bg-destructive/10 text-destructive-text',
        outline: 'border-border text-foreground',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
